import { find } from 'lodash';


export const getMessagingUserFromId = (messagingUserList, id) => {
    return find(messagingUserList, { id });
};

export const hasTeamsConnexion = messagingUsers => messagingUsers.some(user => user.type === 'TEAMS');
